import React from 'react';
import { CTAButton } from '../ui/CTAButton';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section className="py-20 bg-white" data-id="element-91">
      <div className="container mx-auto px-4" data-id="element-92">
        <div className="max-w-lg mx-auto bg-[#FDFCF8] rounded-3xl shadow-2xl border border-stone-100 overflow-hidden" data-id="element-93">
          <div className="bg-stone-900 p-6 text-center" data-id="element-94">
            <h2 className="text-2xl font-bold text-white" data-id="element-95">
              The 7-Day Error-Free System
            </h2>
            <p className="text-stone-400 text-sm mt-1" data-id="element-96">
              Complete Course + All Bonuses
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-97">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-98">
              <span className="text-stone-400 line-through text-xl" data-id="element-99">$197</span>
              <span className="bg-teal-100 text-teal-800 text-xs font-bold px-2 py-1 rounded" data-id="element-100">
                SAVE 75%
              </span>
            </div>
            <div className="text-6xl font-bold text-stone-900 mb-6" data-id="element-101">$47</div>

            <p className="text-stone-500 text-sm mb-8 italic" data-id="element-102">
              "This costs less than the resin you waste in two failed attempts."
            </p>

            <CTAButton fullWidth size="lg" className="mb-6" data-id="element-103">
              Yes, I Want The System
            </CTAButton>

            <div className="space-y-3 text-left max-w-xs mx-auto" data-id="element-104">
              <div className="flex items-center gap-2 text-sm text-stone-600" data-id="element-105">
                <Check className="w-4 h-4 text-teal-600" data-id="element-106" />
                <span data-id="element-107">Instant Login Access</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-stone-600" data-id="element-108">
                <Check className="w-4 h-4 text-teal-600" data-id="element-109" />
                <span data-id="element-110">Lifetime Updates</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-stone-600" data-id="element-111">
                <Check className="w-4 h-4 text-teal-600" data-id="element-112" />
                <span data-id="element-113">Secure Payment</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}